import { useFormik } from 'formik'
import { useEffect, useState } from 'react'
import * as Yup from 'yup'
import axiosClient from '../../../../../setup/axios/axiosClient'
import toast from 'react-hot-toast'

const consumerId = 'nanothread'

const validationSchema = Yup.object({
    firstName: Yup.string().optional(),
    lastName: Yup.string().optional(),
    // email: Yup.string().email('Invalid email format').optional('Email is required'),
})

type ProfileDetailsDataType = {
    firstName: string,
    lastName: string,
    email: string,
}

const useProfileDetailsForm = () => {
    const [initialData, setInitialData] = useState<ProfileDetailsDataType>({
        firstName: '',
        lastName: '',
        email: '',
    })

    const formik = useFormik({
        initialValues: {
            firstName: initialData?.firstName || '',
            lastName: initialData?.lastName || '',
            email: initialData?.email || '',
        },
        validationSchema,
        enableReinitialize: true, // Allows form to update if initialData loads via API
        onSubmit: async (values, { setSubmitting }) => {
            try {
                await updateUserDetails(values)
            } finally {
                setSubmitting(false)
            }
        },
    })

    const fetchUserAccountDetails = async () => {
        try {
            const response = await axiosClient.get<{ userInfo: ProfileDetailsDataType, success: string, message: string }>(`/user/account-details?consumerId=${consumerId}`)
            console.log("response", response)
            if (!response.data?.userInfo) return

            const { email, firstName, lastName } = response.data?.userInfo

            if (response.data) setInitialData({ email, firstName, lastName })
        } catch (error) {
            console.error('Error fetching account details:', error)
        }
    }


    const updateUserDetails = async (data: ProfileDetailsDataType) => {
        try {
            const response = await axiosClient.put(
                `/user/update-account-details?consumerId=${consumerId}`,
                data
            )
            const { email, firstName, lastName } = response.data?.userInfo
            if (response.data.message) { toast.success(response.data.message) }

            if (response.data) setInitialData({ email, firstName, lastName })
        } catch (error) {
            console.error('Error fetching account details:', error)
        } finally {
            await fetchUserAccountDetails()
        }
    }

    useEffect(() => {
        fetchUserAccountDetails()
    }, [])


    return {   // Form State & Handlers
        formData: formik.values,
        handleChange: formik.handleChange,
        handleSubmit: formik.handleSubmit,
        handleBlur: formik.handleBlur,
        setFieldValue: formik.setFieldValue,

        resetForm: formik.resetForm,
        dirty: formik.dirty,

        // Validation State
        errors: formik.errors,
        touched: formik.touched,
        isValid: formik.isValid,
        isSubmitting: formik.isSubmitting,
    }
}

export default useProfileDetailsForm